import styled from "styled-components";

export const ProductInventoryViewWrapper = styled.div`
  width: 100%;
  padding: 2rem;

  @media screen and (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .product-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 2rem;

    .brand {
      font-size: 1.6rem;
      font-weight: 600;
      color: ${({ theme }) => theme.text.primary};
    }
    .meta {
      color: ${({ theme }) => theme.text.muted_200};
      font-size: 1rem;
    }
  }

  .table-wrapper {
    width: 100%;
  }
`;
